import { VrTourPopup } from '../../blocks/optional/partials/vr-tour-popup';

class PopupLink extends VrTourPopup {
  constructor() {
    const dialog = PopupLink.createDialogElement();
    super(null, dialog, { enableFocusTrap: true });

    this.links = document.querySelectorAll('.dialog-content a, a.dialog-content');
    this.innerDialog = dialog ? dialog.querySelector('#dialog-content__body') : null;
  }

  static createDialogElement() {
    if (document.getElementById('popup-container')) return null;

    const wrapper = document.createElement('div');
    wrapper.id = 'popup-container';

    wrapper.innerHTML = `
          <dialog class="dialog-content__overlay">
            <span class="dialog-content__focus-guard" tabindex="0" aria-hidden="true" data-focus-guard="start"></span>
            <div class="dialog-content__window">
              <button class="dialog-content__close" id="dialog-content__close" aria-label="Close dialog">
                <svg aria-hidden="true" focusable="false" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.4449 0.714862L15.73 0L8.22243 7.50757L0.714862 0L0 0.714862L7.50757 8.22243L6.39028 9.33972L0 15.73L0.714862 16.4449L8.22243 8.93729L9.33972 10.0546L15.73 16.4449L16.4449 15.73L8.93729 8.22243L16.4449 0.714862Z" fill="#002045"/>
                </svg>
              </button>
              <div class="dialog-content__body" id="dialog-content__body"></div>
            </div>
            <span class="dialog-content__focus-guard" tabindex="0" aria-hidden="true" data-focus-guard="end"></span>
          </dialog>
        `;

    document.body.appendChild(wrapper);
    return document.querySelector('.dialog-content__overlay');
  }

  init() {
    if (this.links.length === 0 || !this.dialog) return;

    const dialogContent = this.dialog.querySelector('div');
    this.dialogCloser = document.getElementById('dialog-content__close');

    if (!this.dialogCloser || !this.innerDialog) return;

    this.setupFocusTrap();
    this.setupCloseButton(dialogContent);
    this.setupLinks();
  }

  setupCloseButton(dialogContent) {
    this.dialogCloser.addEventListener('click', () => {
      this.closeDialog(dialogContent);
    });
  }

  setupLinks() {
    this.links.forEach((link) => {
      link.addEventListener('click', (e) => {
        this.initializePopup(e);
      });
    });
  }

  initializePopup(e) {
    e.preventDefault();
    const isKeyboardActivation = e.detail === 0;

    const url = this.getValidUrl(e.currentTarget.href);
    if (!url) return;

    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    const dialogContent = this.dialog.querySelector('div');
    if (dialogContent) {
      dialogContent.classList.remove('dialog-content__window--fade-in');
    }

    if (this.dialogCloser) {
      this.dialogCloser.removeAttribute('tabindex');
    }

    this.loadPage(url);
    if (!this.dialog.open) {
      this.dialog.showModal();
    }

    setTimeout(() => {
      document.body.classList.add('dialog-open');
    }, 500);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (dialogContent) {
          dialogContent.classList.add('dialog-content__window--fade-in');
        }
        if (isKeyboardActivation) {
          this.focusFirstInteractiveElement();
        } else {
          this.clearDialogFocus();
        }
      });
    });
  }

  getDialogFocusableElements() {
    if (!this.dialog) return [];
    const iframe = this.dialog.querySelector('.dialog-content__iframe');
    const elements = [this.dialogCloser, iframe].filter(Boolean);
    return elements.filter((element) => (
      !(element instanceof HTMLButtonElement && element.disabled)
      && element.tabIndex !== -1
    ));
  }

  // eslint-disable-next-line class-methods-use-this
  getValidUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.href);
      if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
        return parsedUrl.href;
      }
      return null;
    } catch {
      return null;
    }
  }

  async loadPage(url) {
    if (!this.innerDialog) return;
    if (this.innerDialog.dataset.loadingUrl === url) return;

    this.innerDialog.innerHTML = `
      <div class="dialog-content__loading" role="status" aria-live="polite">
        Loading...
      </div>
    `;
    this.innerDialog.dataset.loadingUrl = url;

    const iframe = document.createElement('iframe');
    iframe.classList.add('dialog-content__iframe');
    iframe.src = url;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
    } catch (e) {
      this.innerDialog.innerHTML = `
        <div class="dialog-content__loading" role="status" aria-live="polite">
          Unfortunately, the page is unavailable.
        </div>
      `;
      delete this.innerDialog.dataset.loadingUrl;
      return;
    }

    this.innerDialog.innerHTML = '';
    this.innerDialog.appendChild(iframe);
    delete this.innerDialog.dataset.loadingUrl;
  }
}

export default function initializeLinkPopups() {
  const popupLinkObj = new PopupLink();
  popupLinkObj.init();
}
